import { identity, mapObj, isObj } from '@exah/utils';
import { wrapIfMedia } from '../utils';
import { getThemeMedia } from '../getters';

var has = function has(a, b) {
  return b.some(function (key) {
    return a.includes(key);
  });
};

var everyMedia = function everyMedia(props, value, wrapper) {
  if (wrapper === void 0) {
    wrapper = identity;
  }

  var media = getThemeMedia(props);

  if (isObj(value) && has(Object.keys(media), Object.keys(value))) {
    return mapObj(function (k, v) {
      return wrapIfMedia(media[k], wrapper(v));
    }, value);
  }

  return wrapper(value);
};

export { everyMedia };